module.exports = __webpack_public_path__ + "img/deco-2.005ae6f2.svg";